<template>
    <div class="occupation-deed-owners">
        <div
            v-for="(holder, idx) in holders"
            :key="`occupation-deed-owners-person-item-${idx}`"
            class="person">
            <PersonItem
                :value="holder.entity"
                :panelCfg="panelCfg"
                personType="holder"
            />
        </div>
        <div class="common-application-info">
            <template v-for="(key, idx) in commonInfo">
                <div
                    v-if="itemInfo(key)"
                    :key="`occupation-deed-owners-common-${idx}`"
                    :class="['info-item', key]"
                    >
                    <label class="pr-2">{{ $t(`${modelTranslateID}.${key}`) }}:</label>{{ itemInfo(key) }}
                </div>
            </template>

            <div class="fee-info" v-if="fee">
                <div class="fee_charged">
                    <span class="fee">{{ feeFormatted }}</span>
                    <span :class="['fee-paid', {'is-charged': feePaid}]">{{ $t(`${modelTranslateID}.${feePaid ? 'paid' : 'not_paid'}`) }}</span>
                </div>
                <div class="payment-date">
                    <span class="payment-date">{{ itemInfo('payment_at') }}</span>
                </div>
            </div>
        </div>

        <div class="deed-owners-files" v-if="numFiles">
            <p>{{ $t(`${modelTranslateID}.files`) }} <span>{{ numFiles }}</span></p>
            <ViewFile
                v-for="(file, idx) in files"
                :key="`occupation-deed-owners-file-${idx}`"
                :value="file"
            />
        </div>
    </div>
</template>

<script>
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";

export default {
    mixins: [
        CemeteryElementMixin
    ],
    components: {
        PersonItem: () => import(/* webpackChunkName: "cemeteries-personitem" */ './PersonItem'),
        ViewFile: () => import(/* webpackChunkName: "cemeteries-viewfile" */ './ViewFile'),
    },
    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            commonInfo: [
                'right_type',
                'term_right_type',
                'application_at',
                'expiry_at',
                'certificate_number',
                'process_number',
                'license_number',
                'registration_number',
                'service_need',
            ]
        }
    },
    computed: {
        modelTranslateID() {
            return `${this.baseTranslateID}.model.deed_owner`
        },
        deed_owners() {
            return this.value ?? [];
        },
        deed_owner() {
            return (this.deed_owners.length ? this.deed_owners[0] : null) ?? {};
        },
        fee() {
            return this.deed_owner?.fee;
        },
        feeFormatted() {
            return this.deed_owner?.fee_formatted ?? this.fee;
        },
        feePaid() {
            return !!this.deed_owner?.fee_paid;
        },
        holders() {
            return this.deed_owner?.holders ?? [];
        },
        files() {
            return this.deed_owner?.files ?? [];
        },
        numFiles() {
            return this.files.length;
        }
    },
    methods: {
        itemInfo(key) {
            return this.deed_owner[key];
        }
    },
}
</script>

<style lang="scss" scoped>
.occupation-deed-owners {
    padding: 24px 16px 16px;

    .person {
        margin-bottom: 8px;
    }

    .common-application-info {
        .info-item {
            padding-top: 8px;
            color: rgb(24, 20, 41);

            label {
                color: rgba(24, 20, 41, .6);
                margin-right: 10px;
                margin-bottom: 0;
                font-size: 16px;
            }
        }
    }

    .fee-info {
        padding: 11px 16px;
        background: rgba(39, 174, 96, .05);
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        margin: 8px 0;

        .fee_charged {
            display: flex;
            align-items: center;

            .fee {
                font-family: var(--city-medium-font-family);
                font-weight: 500;
                font-size: 20px;
                line-height: 24px;
                margin-right: 10px;
            }

            .fee-paid {
                border-radius: 4px;
                text-align: center;
                letter-spacing: .5px;
                text-transform: uppercase;
                font-weight: 700;
                font-size: 10px;
                line-height: 10px;
                padding: 4px;
                background: rgba(0, 0, 0, .4);
                color: #000;
            }
            .is-charged {
                background: rgba(39, 174, 96, .21);
                color: #27ae60;
            }
        }

        .payment-date {
            color: rgba(24, 20, 41, .6);
            font-size: 14px;
            line-height: 16px;
            align-self: center;
        }
    }

    .deed-owners-files {
        margin-top: 16px;

        p {
            font-family: var(--city-medium-font-family);
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            color: rgba(0, 0, 0, .75);
            margin-bottom: 10px;

            span {
                color: rgba(24, 20, 41, .6);
            }
        }
    }
}
</style>